import { j as e } from "../../../../_virtual/jsx-runtime.js";
const d = ({
  cx: r,
  cy: s,
  color: i,
  onMouseEnter: l,
  onMouseLeave: n,
  onClick: t,
  ...o
}) => /* @__PURE__ */ e.jsxs(
  "g",
  {
    className: t ? "cursor-pointer" : "",
    transform: `translate(${r},${s})`,
    onMouseEnter: l,
    onMouseLeave: n,
    onClick: t,
    ...o,
    children: [
      /* @__PURE__ */ e.jsx("circle", { r: "16", fill: i }),
      /* @__PURE__ */ e.jsx(
        "text",
        {
          x: "0",
          y: "0",
          textAnchor: "middle",
          fill: "white",
          dominantBaseline: "middle",
          fontSize: "20",
          fontWeight: "bold",
          children: "!"
        }
      )
    ]
  }
);
export {
  d as default
};
